var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "ForwardArrow",

    getDefaultProps () {
        return {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1","xmlns":"http://www.w3.org/2000/svg","data-svgreactloader":"[[\"http://www.w3.org/2000/svg\",\"xlink\",\"http://www.w3.org/1999/xlink\"]]"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>Material/Icons black/arrow back</title>
  <desc>Created with Sketch.</desc>
  <defs/>
  <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g id="Material/Icons-black/arrow-back" fill="currentColor">
      <polygon id="Shape" transform="translate(12.000000, 12.000000) rotate(180.000000) translate(-12.000000, -12.000000) " points="20 11 7.8 11 13.4 5.4 12 4 4 12 12 20 13.4 18.6 7.8 13 20 13"/>
    </g>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./assets/icons/forward-arrow.svg
 **/